<template>
  <div class="h-workbench-menu">
    <template v-for="item in menuData">
      <!-- <div
        class="tdw-cc-group-link tdw-cc-group-link-min"
        @click="goToLink(item)"
      > -->
      <div :class="getClassName(item)" @click="goToLink(item)">
        <div class="tdw-cc-t-info">{{ item.subName }}</div>
        <div class="tdw-link-icon">
          <img :src="item.icon" alt="" />
        </div>
        <div class="tdw-link-text">{{ item.name }}</div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: ["menuData"],
  data() {
    return {};
  },
  mounted() {
    localStorage.removeItem("menusTitleAry");
  },
  methods: {
    goToLink(item) {
      this.$router.push(item.path);
    },
    getClassName(item) {
      let className = "";
      let menusTitleAry = localStorage.getItem("menusTitleAry")
        ? localStorage.getItem("menusTitleAry")
        : "";
      if (this.menuData.length > 5) {
        if (item.subName.indexOf("Precision") !== -1) {
          if (this.findMenuSubNameFlag("Precision") == false) {
            className = "tdw-cc-group-link tdw-cc-group-link-min Precision";
          } else {
            className = "tdw-cc-group-link tdw-cc-group-link-min";
          }
        } else if (item.subName.indexOf("Genemics") !== -1) {
          if (this.findMenuSubNameFlag("Genemics") == false) {
            className = "tdw-cc-group-link tdw-cc-group-link-min Genemics";
          } else {
            className = "tdw-cc-group-link tdw-cc-group-link-min";
          }
        }
      } else {
        if (item.subName.indexOf("Precision") !== -1) {
          if (this.findMenuSubNameFlag("Precision") == false) {
            className = "tdw-cc-group-link Precision";
          } else {
            className = "tdw-cc-group-link";
          }
        } else if (item.subName.indexOf("Genemics") !== -1) {
          if (this.findMenuSubNameFlag("Genemics") == false) {
            className = "tdw-cc-group-link Genemics";
          } else {
            className = "tdw-cc-group-link";
          }
        }
      }
      menusTitleAry += item.subName + ",";
      localStorage.setItem("menusTitleAry", menusTitleAry);
      return className;
    },
    findMenuSubNameFlag(name) {
      let flag = false;
      let menusTitleAry = localStorage.getItem("menusTitleAry");
      if (!menusTitleAry) {
        flag = false;
      } else if (menusTitleAry.indexOf(name) !== -1) {
        flag = true;
      }
      return flag;
    },
  },
};
</script>

<style lang="scss" scoped>
.h-workbench-menu {
  .tdw-cc-t-info {
    font-size: 12px;
    font-weight: 400;
    color: #9b9b9b;
    line-height: 17px;
    position: absolute;
    top: -19px;
    display: none;
  }
  .tdw-cc-group-link {
    position: relative;
    float: left;
    width: 180px;
    height: 180px;
    background: rgba(66, 142, 247, 0.05);
    text-align: center;
    margin: 25px 20px 0px 0;
    padding: 52px 0;
    cursor: pointer;
    &:hover {
      background-color: #ffffff;
      -webkit-box-shadow: 2px 2px 5px 0px rgba(0, 0, 0, 0.23);
      box-shadow: 2px 2px 5px 0px rgba(0, 0, 0, 0.23);
    }
  }
  .Precision .tdw-cc-t-info,
  .Genemics .tdw-cc-t-info {
    display: block;
  }
  .tdw-link-icon {
    width: 43px;
    height: 42px;
    margin: 0 auto;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  .tdw-link-text {
    font-size: 16px;
    color: #646464;
    line-height: 34px;
  }
  .tdw-cc-group-link-min {
    height: 80px;
    padding: 18px 0;
    .tdw-link-icon {
      float: left;
      width: 50%;
    }
    .tdw-link-text {
      float: right;
      width: 50%;
      text-align: left;
      line-height: 44px;
    }
  }
}
</style>